import {
  AdgroupFormData,
  AdType,
  CampaignFormData,
  genDestinationUrlTypes,
  NormalCreative,
  DestinationUrlType,
  FullNormalFormData,
  AcoFormData,
  VerticalCreativeStrategy,
} from '@tt4b/ttam-enums';
import { computed, Ref } from '@vue/composition-api';
import { getAdTypeByNormalCreativeData } from '@tt4b/ttam-utils';
import { useStdAdgroupIs, useDlpFormStatus } from '@tt4b/ttam-hooks';

export function usePropsOptions(props: {
  adgroupFormData: Ref<AdgroupFormData>;
  campaignFormData: Ref<CampaignFormData>;
  creativeFormData: Ref<FullNormalFormData & AcoFormData>;
  normalCreativeData: Ref<NormalCreative>;
}) {
  const { normalCreativeData, adgroupFormData, campaignFormData, creativeFormData } = props;

  const { needRewriteStrategy } = useDlpFormStatus({
    adgroupFormData,
    campaignFormData,
    creativeFormData,
  });

  const currentAdType = computed(() => getAdTypeByNormalCreativeData(normalCreativeData.value));
  const { isOnlyPangle } = useStdAdgroupIs({
    campaignFormData: campaignFormData as any,
    adgroupFormData: adgroupFormData as any,
  });

  const options = computed(() => {
    let destinationUrlTypes = Object.values(genDestinationUrlTypes());
    if (
      (isOnlyPangle.value && AdType.CATALOGUE_VIDEO === currentAdType.value) ||
      currentAdType.value === AdType.CATALOGUE_IMAGE ||
      (creativeFormData.value.verticalCreativeStrategy === VerticalCreativeStrategy.SMART_CREATIVE &&
        needRewriteStrategy.value)
    ) {
      destinationUrlTypes = destinationUrlTypes.filter(urlType => urlType.name !== DestinationUrlType.instantPage);
    }
    // 不需要展示的过滤
    destinationUrlTypes = destinationUrlTypes.filter(urlType => urlType.name !== DestinationUrlType.productPage);
    return destinationUrlTypes.map(o => ({
      ...o,
      trackProps: {
        'data-tea-type': o.name,
        'data-tea': 'ad_destination_url_type_selector_click',
        'data-tea-expose': 'ad_destination_url_type_selector_expose',
        'data-tea-pixel-type': adgroupFormData?.value?.promotionWebsiteType,
      },
    }));
  });
  return {
    options,
  };
}
